import type { SVGProps } from 'react'
const SvgSyBookmark = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M8.791 1.55c-1.41 0-2.712.265-3.717.985S3.45 4.463 3.45 5.971v14.722c0 1.264 1.43 2.101 2.531 1.483l6.014-3.373 5.96 3.367h.001c1.103.621 2.533-.215 2.533-1.48V6.153c0-1.546-.577-2.792-1.572-3.554-.995-.763-2.31-1.05-3.766-1.05zm0 1.5h6.36c1.251 0 2.23.264 2.853.741.622.477.984 1.159.984 2.363V20.69c0 .189-.132.267-.297.174l-6.326-3.574a.75.75 0 0 0-.736-.002l-6.383 3.58c-.163.092-.297.014-.297-.174V5.971c0-1.136.364-1.763.998-2.217.635-.455 1.63-.703 2.844-.703"
				clipRule="evenodd"
			/>
			<path
				d="M8.271 8.277a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h7.319a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyBookmark
